import React from "react";
import { Link } from "react-router-dom";
import "./ui.scss";

export const Breadcrumbs = ({ items = [] }) => {
  if (items.length === 0) return null;
  return (
    <nav className="hr-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <React.Fragment key={`${item.label}-${index}`}>
              <li>
                {item.to && !isLast ? (
                  <Link to={item.to}>{item.label}</Link>
                ) : (
                  <span aria-current={isLast ? "page" : undefined}>
                    {item.label}
                  </span>
                )}
              </li>
              {!isLast && (
                <li aria-hidden="true">
                  <span>/</span>
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

const PageHeader = ({ breadcrumbs = [], title, subtitle, actions }) => (
  <div className="hr-page-header">
    <div className="hr-page-header__main">
      <Breadcrumbs items={breadcrumbs} />
      <h1 className="hr-page-title">{title}</h1>
      {subtitle && <p className="hr-page-subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="hr-page-header__actions">{actions}</div>}
  </div>
);

export default PageHeader;
